//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/NXObject.js";
import "../GeometricUtilities/GeometricUtilities.Extend.js";
import "../no/Expression.js";
let d=[[[0,"IsEndSection",1,0],[0,"IsStartSection",1,0],[1,"OnPathDimData",0,"GeometricUtilities.Extend",0]],[[["nExps"],"GetSecondarySectionValues",{R_:{expressions:""}},0,0],[["expressions"],"SetSecondarySectionValues",{},1,0],[["num_exp"],"GetMasterExpressionValues",{R_:{expressions:"Expression[]"}},0,0],[["expressions"],"SetMasterExpressionValues",{},1,0],[["pathLocationPercent"],"SetPathLocation",{},1,0],[[],"Destroy",{},0,0],[["masterSection"],"SetMasterSection",{},1,0],[["pathLocation"],"CreateSketch",{},1,0],[[],"DeleteSketch",{},0,0]],[]];
SPLM.GeometricUtilities.SecondarySectionData = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.SecondarySectionData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;